import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import songsAPI from "restApi/songsApi";
import { lyricsProgress, thanksMessage } from "utils/catalogProgress";

// Shown on the song page right after someone adds lyrics to a song that had
// none (SongEditPage passes `lyricsThanks` in the navigation state): a thank-you
// and how many songs still need lyrics. The state is cleared straight away, so a
// refresh or going back doesn't show it a second time.
export default function LyricsThanks() {
  const location = useLocation();
  const history = useHistory();
  const [message, setMessage] = React.useState("");
  const thanks = Boolean(location.state && location.state.lyricsThanks);

  React.useEffect(() => {
    if (!thanks) return;
    const { lyricsThanks, ...rest } = location.state;
    history.replace({ ...location, state: Object.keys(rest).length ? rest : undefined });
    songsAPI
      .getSongs()
      .then((res) => setMessage(thanksMessage(lyricsProgress(res.data).missing)))
      // Can't count the gaps: still say thank you.
      .catch(() => setMessage("Thank you for adding lyrics!"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thanks]);

  return (
    <Snackbar open={Boolean(message)} autoHideDuration={7000} onClose={() => setMessage("")}>
      <Alert severity="success" onClose={() => setMessage("")}>
        {message}
      </Alert>
    </Snackbar>
  );
}
